import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { NavBar, Fotter, PWA, SecondaryNav, Loader } from 'components';
import { AuthGuard } from 'context/AuthContext';
import { useApp } from 'context/AppContext';
import { Error } from 'status';
import { getLoginCount } from 'utils/auth';
import { ContentWrapper, HeaderContainer, LayoutContainer, PageWrapper } from './Styles';

const MainLayout = ({ isInstalled, handlePwaButton }) => {
  const { state } = useApp();
  const { isError } = state;
  const location = useLocation();

  const showSecondaryNav = location.pathname.startsWith('/store');
  const isFaqPage = location.pathname === '/faq';
  const isIframeView = isFaqPage || location.pathname === '/webview';

  const loginCount = getLoginCount();
  const userAgent = navigator.userAgent;
  const isMobile = 'ontouchstart' in window || navigator.msMaxTouchPoints;
  const isIos = /iPhone|iPad|iPod|Mac/i.test(userAgent);
  const isSafari = /Version\/[\d.]+.*Safari/i.test(userAgent) && !('webkit' in window);
  const isEdge = /Edg/i.test(userAgent);
  const shouldShowPWA = !isInstalled && isMobile && ((!isIos && !isEdge) || (isSafari && loginCount <= 3));

  return (
    <AuthGuard>
      <LayoutContainer $isFaqPage={isFaqPage}>
        <HeaderContainer>
          <NavBar />
          {showSecondaryNav && <SecondaryNav />}
        </HeaderContainer>

        <ContentWrapper $isFaqPage={isFaqPage}>
          {isError ? (
            <Error />
          ) : (
            <Suspense fallback={<Loader fullHeight />}>
              <PageWrapper key={location.pathname} $isFaqPage={isFaqPage}>
                <Outlet />
              </PageWrapper>
            </Suspense>
          )}
        </ContentWrapper>

        {shouldShowPWA && !isIframeView && <PWA isIos={isIos} handlePwaButton={handlePwaButton} />}
        <Fotter />
      </LayoutContainer>
    </AuthGuard>
  );
};

export default MainLayout;
